<template>
    <div class="main-content">
        <section class="section">
            <div class="section-header d-block">
                <h1 class="text">{{this.$route.meta.title}}</h1>
                <div class="card-header-action mt-3 card-report">
                    <button v-b-modal.bv-modal-Sorting type="button" class="btn btn-light">
                        Selected statistics from {{sorting_date}}
                        <i class="ml-2 align-middle uil uil-angle-down"></i>
                    </button>
                </div>
            </div>

            <div class="section-body">
                <b-row class="mt-4">
                    <b-col md="3">
                        <b-card no-header class="card-statistic bdr-15">
                            <div class="card-stats">
                                 <div class="cst-icon">
                                    <i class="w-100 uil uil-users-alt"></i>
                                 </div>
                                 <div class="cst-cnt mt-3">
                                     <h5 class="mb-0">Distributor</h5>
                                     <p class="mb-0">Total Distributor</p>
                                 </div>
                                 <div class="cst-val">
                                     <h4 class="w-100 mb-0">{{reports.distributors}}</h4>
                                 </div>
                            </div>
                        </b-card>
                    </b-col>
                    <b-col md="3">
                        <b-card no-header class="card-statistic bdr-15">
                            <div class="card-stats">
                                 <div class="cst-icon">
                                    <i class="w-100 uil uil-user-arrows"></i>
                                 </div>
                                 <div class="cst-cnt mt-3">
                                     <h5 class="mb-0">Agent</h5>
                                     <p class="mb-0">Total Agent</p>
                                 </div>
                                 <div class="cst-val">
                                     <h4 class="w-100 mb-0">{{reports.agents}}</h4>
                                 </div>
                            </div>
                        </b-card>
                    </b-col>
                    <b-col md="3">
                        <b-card no-header class="card-statistic bdr-15">
                            <div class="card-stats">
                                 <div class="cst-icon">
                                    <i class="w-100 uil uil-parcel"></i>
                                 </div>
                                 <div class="cst-cnt mt-3">
                                     <h5 class="mb-0">Event</h5>
                                     <p class="mb-0">Total Event</p>
                                 </div>
                                 <div class="cst-val">
                                     <h4 class="w-100 mb-0">{{reports.events}}</h4>
                                 </div>
                            </div>
                        </b-card>
                    </b-col>
                    <b-col md="3">
                        <b-card no-header class="card-statistic bdr-15">
                            <div class="card-stats">
                                 <div class="cst-icon">
                                    <i class="w-100 uil uil-ticket"></i>
                                 </div>
                                 <div class="cst-cnt mt-3">
                                     <h5 class="mb-0">Slot Sale</h5>
                                     <p class="mb-0">Total Slot Sale</p>
                                 </div>
                                 <div class="cst-val">
                                     <h4 class="w-100 mb-0">{{reports.slots_sales}}</h4>
                                 </div>
                            </div>
                        </b-card>
                    </b-col>
                    <b-col md="12">
                        <h5 class="mb-4">Event Statistic</h5>
                        <b-card no-header class="card-statistic bdr-15">
                            <canvas id="chart-events"></canvas>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
        </section>

        <b-modal id="bv-modal-Sorting" centered hide-header hide-footer>
            <div class="form-row mt-4">

                <div class="form-group col-md-12">
                    <label>Report Type</label>
                    <v-select :clearable="false" label="label" :reduce="sorting_type => sorting_type.value" v-model="sorting_report.date_type" :options="sorting_type"></v-select>
                </div>

                <div class="form-group col-md-12">
                    <label>Chart Type</label>
                    <v-select :clearable="false" label="label" :reduce="type_chart => type_chart.value" v-model="sorting_report.chart_type" :options="type_chart"></v-select>
                </div>

                <template v-if="sorting_report.date_type === 'custom'">
                    <div class="form-group col-md-12">
                        <label>Start Date</label>
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">
                                    <i class="uil uil-calendar-alt"></i>
                                </div>
                            </div>
                            <datetime v-model="sorting_report.start_date" type="date" input-class="form-control"></datetime>
                        </div>
                    </div>

                    <div class="form-group col-md-12">
                        <label>End Date</label>
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">
                                    <i class="uil uil-calendar-alt"></i>
                                </div>
                            </div>
                            <datetime :min-datetime="sorting_report.start_date" v-model="sorting_report.end_date" type="date" input-class="form-control"></datetime>
                        </div>
                    </div>
                </template>

                <div class="form-group col-md-12 mb-0">
                    <button v-on:click="sortingReports()" class="btn btn-new"><i class="uil uil-search mr-1"></i> Search Reports</button>
                </div>
            </div>

        </b-modal>
    </div>
</template>

<script>
    import { mapActions, mapState, mapMutations } from 'vuex'
    import moment from 'moment'
    import { Datetime } from 'vue-datetime';
    import vSelect from 'vue-select'
    import Chart from 'chart.js';
    import chartData from '../../../utils/chart-data.js';

    export default {
        data() {
            return {
                sorting_date:'',

                chart_events_format: chartData.EventsChart,
                chart_events: [],
            }
        },
        mounted(){
            this._getAdminReports()
        },
        components: {
            Datetime,
            vSelect,
        },
        computed:{
            ...mapState('DashboardControl', {
                reports: state => state.reports,
                type_chart: state => state.type_chart,
                sorting_type: state => state.sorting_type,
                sorting_report: state => state.sorting_report,
            }),
        },
        filters: {
            formatDate: function(val){
                return moment(String(val)).format('DD MMMM YYYY')
            }
        },
        methods:{
            ...mapActions('DashboardControl', ['getReportsAdmin']),
            ...mapMutations('DashboardControl', ['CLEAR_SORTING_REPORT']),
            
            sortingType: function(){
                if(this.sorting_report.date_type != 'custom'){
                    this.sorting_type.forEach(data => {
                        if(data.value == this.sorting_report.date_type){
                            this.sorting_date = data.label
                        }
                    });
                }else{
                    this.sorting_date = moment(String(this.sorting_report.start_date)).format('DD MMMM YYYY')   + ' - ' + moment(String(this.sorting_report.end_date)).format('DD MMMM YYYY')
                }
            },
            sortingReports: function(){
                this._getAdminReports();
                this.$bvModal.hide('bv-modal-Sorting')
            },
            _getAdminReports: function(){
                this.getReportsAdmin().then(() => {
                    this.sortingType()
                    this.createChartEvents('chart-events', this.chart_events_format)
                    this.setDataChartEvents()
                });
            },
            createChartEvents(chartId, chartData) {
                const ctx = document.getElementById(chartId);
                this.chart_events = new Chart(ctx, {
                    type: chartData.type,
                    data: chartData.data,
                    options: chartData.options,
                });
            },
            clearChartEvents(chart){
                chart.data.labels.splice(0,chart.data.labels.length);
                chart.data.datasets.forEach((dataset) => {
                    dataset.data.splice(0,dataset.data.length);
                });
                chart.update();
            },
            setDataChartEvents(){
                this.clearChartEvents(this.chart_events)
                for( var i = 0; i < this.reports.events_chart.length; i++ ){
                    this.addDataChartEvents(this.chart_events,this.reports.events_chart[i].date, this.reports.events_chart[i].total);
                }
            },
            addDataChartEvents(chart,label,data){
                chart.data.labels.push(label);
                chart.data.datasets.forEach(dataset => {
                    dataset.data.push(data);
                });
                chart.update();
            },
        },
        destroyed(){
            this.CLEAR_SORTING_REPORT()
        }
    }
</script>